import { render, staticRenderFns } from "./ManufacturersForm.vue?vue&type=template&id=f4abcc94"
import script from "./ManufacturersForm.vue?vue&type=script&lang=js"
export * from "./ManufacturersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports